import { useFormatMessage } from '../../helpers/intl'

export const useFinancialTranslation = () => {
  const taxText = useFormatMessage('dashboard.transactionPage.tax', 'Tax')
  const subTotalText = useFormatMessage('dashboard.transactionPage.subtotal', 'Sub-Total')
  const totalText = useFormatMessage('dashboard.transactionsPage.statsView.total', 'Total')
  const localTaxText = useFormatMessage('dashboard.transactionsPage.local-tax', 'Local Tax')
  const loiteringFeeText = useFormatMessage('dashboard.transactionsPage.loitering-fee', 'Loitering Amount')
  const loiteringDurationText = useFormatMessage('dashboard.transactionsPage.loitering-duration', 'Loitering Duration')
  const chargingFeeText = useFormatMessage('dashboard.transactionsPage.charging-fee', 'Charge Amount')
  const flatFeeText = useFormatMessage('dashboard.transactionsPage.flat-fee', 'Flat Fee')
  const guestFeeText = useFormatMessage('dashboard.transactionsPage.guest-fee', 'Guest Fee')

  return {
    localTaxText,
    taxText,
    subTotalText,
    totalText,
    loiteringFeeText,
    loiteringDurationText,
    chargingFeeText,
    flatFeeText,
    guestFeeText
  }
}
